import { useRef, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

function LazyImage({ alt, className, height, placeholderClassName, placeholderSrc, src, width }) {
    const [isLoading, setIsLoading] = useState(true);
    const placeholderRef = useRef(null);

    return (
        <div className="relative">
            <img
                src={src}
                className={clsx(className, 'absolute transition-all duration-100', { 'opacity-0': isLoading })}
                alt={alt}
                onLoad={() => setIsLoading(false)}
                width={width}
                height={height}
                loading="lazy"
            />
            <img
                src={placeholderSrc}
                className={clsx(placeholderClassName, 'bg-white')}
                alt="placeholder"
                ref={placeholderRef}
                width={width}
                height={height}
            />
        </div>
    );
}

LazyImage.propTypes = {
    alt: PropTypes.string,
    className: PropTypes.string,
    height: PropTypes.number,
    placeholderClassName: PropTypes.string,
    placeholderSrc: PropTypes.string.isRequired,
    src: PropTypes.string.isRequired,
    width: PropTypes.number,
};

LazyImage.defaultProps = {
    alt: '',
    className: '',
    height: 600,
    placeholderClassName: '',
    width: 600,
};

export default LazyImage;
